import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { RaceSessionStatus, RaceSessionType } from '../../../typings/race-session';
import { makeClassNames } from '../../../utils/styles';
import LgpHeader from '../../molecules/lgp-header/lgp-header';

import './lgp-hero-sticky.scss';

export interface ILgpHeroSticky extends IComponent {
  sessionStatus: RaceSessionStatus;
  flagImgUrl: string;
  customGpName: string;
  startDate: string;
  endDate: string;
  sessionName: RaceSessionType;
}

const classNames = () =>
  makeClassNames({
    lgpHeroStickyContainer: 'lgp-hero-sticky__container',
  });

const LgpHeroSticky = ({
  sessionStatus = 'Fixture',
  flagImgUrl,
  customGpName,
  startDate,
  endDate,
  sessionName,
}: ILgpHeroSticky) => {
  const cn = classNames();

  return (
    <div>
      <div className={cn.lgpHeroStickyContainer}>
        <LgpHeader
          flagImgUrl={flagImgUrl}
          customGpName={customGpName}
          startDate={startDate}
          endDate={endDate}
          isSticky
          sessionStatus={sessionStatus}
          sessionName={sessionName}
        />
      </div>
    </div>
  );
};

export default LgpHeroSticky;
